PlanImpressionPrixValidator.$inject = ['validator'];

export default function PlanImpressionPrixValidator(validator) {
    const instance = new validator();

    return instance;
}
